import * as yup from "yup";

const deleteSchema = (translate: Function) => yup.object().shape({
	mdb001Descricao: yup.string().required(translate("Nome do diagnóstico não confere")).oneOf([yup.ref("mdb001DescricaoConfirmation")], translate("Nome do diagnóstico não confere"))
});

const addAndChangeSchema = (translate: Function, isAdd: boolean) => yup.object().shape({
	mdb001Descricao: yup.string().required(translate("Descrição é requerida")),
	mdb001Data: yup.date()
		.required(translate("Data é requerida"))
		.typeError(translate("Data é requerida")),
	mdb001Mda001Id: isAdd ? yup.number().required(translate("Modelo de diagnóstico é requerido")): yup.number().nullable(),
	mdtbb004: yup.array().of(yup.object().shape({
		mdb004Descricao: yup.string().required(translate("Descrição é requerida"))
	}))
});

const changeComparativesSchema = (translate: Function) => yup.object().shape({
	mdtbb005: yup.array().of(yup.object().shape({
		mdb005Complemento: yup.string(),
		mdb005Pontuacao: yup.number().min(0)
			.when("maxScore",(maxScore,schema) => maxScore ? schema.max(maxScore,translate("Pontuação deve ser menor ou igual a pontuação máxima")) : schema)
	}))
});


export { deleteSchema, addAndChangeSchema, changeComparativesSchema };
